// This file is auto-generated. Do not edit directly.
// Generated from configuration/groups/pacesetter/document-mappings.yaml
// Run: bun run scripts/mappings/pacesetter-make-mappings-from-yaml.ts
import { DocumentMapping } from "@/configuration/document-mappings/types";
import { Classification } from "@/src/models/constants/classifications";

export const PACESETTER_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.REFERRAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Schedule",
      "Task Details: {{ dateReceived }} Referral",
      "Task Note: {{ referringProvider }} referral for {{ reasonForReferral }}; no imaging mentioned. Schedule accordingly"
    ],
    assignedTo: null,
    displayName: "Referral",
    documentLabel: "{{ dateReceived }} Referral",
    folder: "Referral",
    folderMapping: "Referral",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Inbound Referral WF",
    priority: "Normal",
    classification: Classification.REFERRAL,
    group: "pacesetter"
  }
} as const;
